import { cn } from "@/lib/utils";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";

import { Button } from "@/components/ui/button";
import { Form } from "@/components/ui/form";
import { distributorRegistrationSchema } from "@/schemas/DistributorRegistrationSchema";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../ui/card";
import { CustomFormField } from "@/components";

import { distributorRegistrationFormFields } from "@/utils/FormFields";
import { FormFieldConfig } from "@/types/AppTypes";

import { LoaderCircle } from "lucide-react";

import { useSignUpUser } from "@/hooks";

export default function DistributorSignUpForm({
  onSubmit: onFormSubmit,
  loading: externalLoading,
  className,
  ...props
}: Omit<React.ComponentPropsWithoutRef<"div">, "onSubmit"> & { 
  onSubmit: (data: z.infer<typeof distributorRegistrationSchema>) => void | Promise<void>;
  loading?: boolean;
}) {
  const { handleSignUp, loading: hookLoading } = useSignUpUser();
  
  // Use external loading if provided, otherwise use hook loading
  const loading = externalLoading !== undefined ? externalLoading : hookLoading;

  const form = useForm<z.infer<typeof distributorRegistrationSchema>>({
    resolver: zodResolver(distributorRegistrationSchema),
    defaultValues: {
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      confirmPassword: "",
    },
  });

  const renderFormField = (field: FormFieldConfig) => (
    <CustomFormField
      key={field.name || ""}
      control={form.control}
      name={field.name || "unnamed"}
      label={field.label || ""}
      placeholder={field.placeholder}
      type={field.type || "text"}
      className={field.className}
      required={field.required || false}
      disabled={field.disabled || false}
    />
  );

  const handleSubmit = async (data: z.infer<typeof distributorRegistrationSchema>) => {
    await onFormSubmit(data);
  };

  console.log(form.formState.errors);

  
    // await handleSignUp({
    //   email: values.email,
    //   password: values.password,
    //   firstName: values.firstName,
    //   lastName: values.lastName,
    // });
 

  return (
    <div
      className={cn("flex flex-col gap-6 shadow-sm w-full h-full rounded-lg ", className)}
      {...props}
    >
      <Card>
        <CardHeader className="">
          <CardTitle className="text-2xl">Register</CardTitle>
          <CardDescription className="text-palette-text">
            Create a new beauty professional account
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Form {...form}>
            <form onSubmit={form.handleSubmit(handleSubmit)} className="space-y-6">
              <div className="flex flex-col md:flex-row gap-4">
                {distributorRegistrationFormFields.slice(0, 2).map((field) => (
                  <div key={field.name} className="flex-1">
                    {renderFormField(field)}
                  </div>
                ))}
              </div>

              {distributorRegistrationFormFields.slice(2).map(renderFormField)}

              <Button
                disabled={loading}
                type="submit"
                className="w-full bg-black text-white hover:bg-gray-800 h-11"
              >
                {loading ? (
                  <>
                    <LoaderCircle className="mr-2 h-4 w-4 animate-spin" />
                    <span>Please wait...</span>
                  </>
                ) : (
                  "Create Account"
                )}
              </Button>

              <div className="text-center text-sm text-gray-500 mt-4">
               
              </div>
            </form>
          </Form>
        </CardContent>
      </Card>
    </div>
  );
}
